export function getBaseScrollableStackStyle(theme, isScrollbarForcedVisible, isScrollbarForcedFullyVisible) {
    const activeScrollbarStyle = {
        background: theme.customSemanticColors.controlFillSecondary,
        backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='8' fill='" +
            theme.customSemanticColors.controlStrongFillDefault +
            "'><polygon points='4,0 0,4 8,4'/></svg>\")," +
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='8' fill='" +
            theme.customSemanticColors.controlStrongFillDefault +
            "'><polygon points='0,0 8,0 4,4'/></svg>\")",
        // First pixel adjustment moves the top button up by 8px which results in a 6px gap between it and the thumb:hover
        // Second pixel adjustment moves the bottom button down by 12px which results in a 6px gap between it and the thumb:hover
        // Adjustments may require .5px values due to how borders/rounded edges are computed.
        backgroundPosition: "center top -8px, center bottom -12px",
        backgroundRepeat: "no-repeat",
    };
    // Note: there is framework flaw which prevents this scrollbar from being themed correctly in high contrast.
    // DevTools does not show the colors as being overridden and forcing a behavior via forced-colors also does not work
    // So: no matter what colors are specified, Windows HC does the default behavior of setting the colors whatever it thinks they should be for HC.
    // This is likely due to the scrollbar being a psuedo-element and\or with an inline style; however
    // it's unclear if other pseudeo-elements share the same flaw or if it's restricted to just webkit-scrollbar.
    // The only other solution would be to create the scrollbar as its own element rather than a style on the Stack
    // but that is obviously a large change that would carry risk in implementing
    // See http://osgvsowi/36064204 for the original bug investigation that revealed this flaw
    return {
        root: {
            "::-webkit-scrollbar": Object.assign({ ":active, :hover": activeScrollbarStyle, background: theme.customSemanticColors.controlFillTransparent, border: "12px solid " + theme.customSemanticColors.controlFillTransparent, borderRadius: "6px", width: "12px" }, (isScrollbarForcedFullyVisible && activeScrollbarStyle)),
            "::-webkit-scrollbar-button:single-button": {
                height: "8px",
                width: "8px",
            },
            "::-webkit-scrollbar-thumb": {
                ":hover, :active": {
                    border: "3px solid " + theme.customSemanticColors.controlFillTransparent,
                    display: "block",
                },
                background: theme.customSemanticColors.controlStrongFillDefault,
                backgroundClip: "content-box",
                border: "5px solid " + theme.customSemanticColors.controlFillTransparent,
                borderRadius: "6px",
                display: isScrollbarForcedVisible || isScrollbarForcedFullyVisible ? "block" : "none",
            },
            ":active, :hover": {
                "::-webkit-scrollbar-thumb": {
                    display: "block",
                },
            },
            height: "100%",
            marginRight: "-12px" /* scrollbar width */,
            overflowX: "hidden",
            overflowY: "scroll",
        },
    };
}
